import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React, { useEffect, useMemo, useContext } from 'react';
import 'prismjs/components/prism-markdown.js';
import "./index.css";
import { EditorContext } from '../../Context';
import Markdown from './Markdown';
import Textarea from './Textarea';
export default function TextArea(props) {
  var _ref = props || {},
    prefixCls = _ref.prefixCls,
    className = _ref.className,
    onScroll = _ref.onScroll;
  var _useContext = useContext(EditorContext),
    scrollTop = _useContext.scrollTop,
    dispatch = _useContext.dispatch;
  var warp = /*#__PURE__*/React.createRef();
  useEffect(function () {
    var state = {};
    if (warp.current) {
      state.textareaWarp = warp.current || undefined;
      warp.current.scrollTop = scrollTop || 0;
    }
    if (dispatch) {
      dispatch(_objectSpread({}, state));
    }
  }, []);
  return useMemo(function () {
    return /*#__PURE__*/React.createElement("div", {
      ref: warp,
      className: "".concat(prefixCls, "-aree ").concat(className || ''),
      onScroll: onScroll
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-text")
    }, /*#__PURE__*/React.createElement(Markdown, {
      prefixCls: prefixCls
    }), /*#__PURE__*/React.createElement(Textarea, {
      prefixCls: prefixCls
    })));
  }, []);
}